import { render, staticRenderFns } from "./export-product-attribute-values-versions-index.vue?vue&type=template&id=7d9fa25a&"
import script from "./export-product-attribute-values-versions-index.vue?vue&type=script&lang=js&"
export * from "./export-product-attribute-values-versions-index.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports